import axios from 'axios'

export class ImpersonationApi {
    static async accept(id) {
        const response = await axios.put(route('backoffice.impersonation.accept', { id }))
        return response.data
    }

    static async deny(id) {
        const response = await axios.put(route('backoffice.impersonation.refuse', { id }))
        return response.data
    }
}
